// init reveal effect
export default function initReveal() {
  var revealElements = document.querySelectorAll(
    ".anim-group, .anim-elem"
  );

  revealElements.forEach((element) => {
    element.classList.add("reveal-active");

    setTimeout(() => {
      libs.ScrollTrigger.create({
        trigger: element,
        start: "top bottom-=100px",
        toggleClass: {
          targets: element,
          className: "reveal-visible",
        },
        once: true
      });
    }, 100);
  });
}
